// @import dependencies
import React, {Component} from 'react'
import { connect } from 'react-redux'
import { CombinedReducers as IState } from 'app_events/index'
// @end

// @import components
import {CourseSchedulingDetailListModuleLayout} from 'app_components/modules/courseSchedulingDetailList'
// @end

// @import events
// @end

// @import utils
// @end

// @import services
import CourseSchedulingDetailsService from 'app_services/admin/courseScheduling/courseSchedulingDetailsService'
// @end

// @import types
import { ICourseSchedulingDetailListItem, ICourseSchedulingDetailsHttpResponse } from 'app_types/admin/courseScheduling/courseSchedulingDetailsTypes'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
// @end

// @ADD Component types
interface ICourseSchedulingDetailListModuleProps {
  courseScheduling: ICourseSchedulingListItem
}
interface ICourseSchedulingDetailListModuleState {
  status: null | 'loading' | 'error'
  itemList: ICourseSchedulingDetailListItem[]
}

// @INFO: Connect react storage state
const mapStatesToProps = (state: IState) => {return state}

class CourseSchedulingDetailListModule extends Component<ICourseSchedulingDetailListModuleProps, ICourseSchedulingDetailListModuleState> {

  private itemService: CourseSchedulingDetailsService

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor(props: ICourseSchedulingDetailListModuleProps) {
    super(props)
    this.state = {
      status: 'loading',
      itemList: [],
    }
    this.itemService = new CourseSchedulingDetailsService()
  }

  /**
   * Evento que se ejecuta cuando el componente es montado
   */
  componentDidMount = async () => {
    this.fetchCourseSchedulingDetailsList()
  }

  /**
   * Evento que se ejecuta cuando el componente es desmontado
   */
  componentWillUnmount = () => {}

  /**
   * Evento que se ejecuta cuando el componente es actualizado
   */
  componentDidUpdate = () => {}

  // @Add custom methods

  fetchCourseSchedulingDetailsList = async () => {
    this.setState({ status: 'loading' })

    const httpParams: any = {
      // pageNumber: params?.page ? params?.page : this.state.pagination.page,
      // nPerPage: params?.perPage ? params?.perPage : this.state.pagination.perPage,
      isActive: false,
      sort: JSON.stringify({
        field: 'startDate',
        direction: "1"
      })
    }

    // if (params?.search) {
    //   httpParams.search = params?.search
    // }

    if (this.props.courseScheduling) {
      httpParams.course_scheduling = this.props.courseScheduling._id
    }

    let itemList: ICourseSchedulingDetailsHttpResponse | null = await this.itemService.list(httpParams)

    if (itemList?.status_code === 'success') {
      this.setState({
        itemList: itemList?.schedulings,
        status: null,
      })

    } else {
      this.setState({ status: 'error' })
    }
  }

  render() {
    return(
      <CourseSchedulingDetailListModuleLayout
        status={this.state.status}
        itemList={this.state.itemList}
      />
    )
  }
}

export default connect(mapStatesToProps)(CourseSchedulingDetailListModule)
